import React from 'react';
import PropTypes from 'prop-types';
import {Toolbar, Grid, Typography, Button, Chip, Tooltip} from '@material-ui/core';

function ImportedProjectLobbyActionToolbar(props) {
  const {onCustomiseProject, onViewTimelines, projectSelected, numProjects, isAdmin} = props;

  return (
    <Toolbar>
      <Grid container justify="space-between" alignItems="center" spacing={2}>
        <Grid item>
          <Grid container spacing={3}>
            <Grid item>
              <Typography variant="h5" style={{color: 'grey'}}>
                Project Lobby
              </Typography>
            </Grid>
            <Grid item>
              <Tooltip title="Total Projects">
                <Chip variant="outlined" label={numProjects} />
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>

        {projectSelected && isAdmin && (
          <Grid item>
            <Grid container spacing={3} alignItems="center">
              <Grid item>
                <Button variant="outlined" onClick={onCustomiseProject} color="primary">
                  Customise Project
                </Button>
              </Grid>
              <Grid>
                <Button
                  variant="outlined"
                  onClick={onViewTimelines}
                  color="secondary"
                  style={{marginRight: 20}}
                >
                  View Timelines
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Toolbar>
  );
}

ImportedProjectLobbyActionToolbar.propTypes = {
  projectSelected: PropTypes.bool.isRequired,
  onCustomiseProject: PropTypes.func.isRequired,
  onViewTimelines: PropTypes.func.isRequired,
  numProjects: PropTypes.number.isRequired,
  isAdmin: PropTypes.bool.isRequired,
};

export default ImportedProjectLobbyActionToolbar;
